import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.4023 18C20.9546 17.9987 21.4012 17.5499 21.3999 16.9976C21.3986 16.4454 20.9498 15.9987 20.3975 16L9.30497 16.0264L9.0241 15H18.2362C18.6872 15 19.0824 14.6982 19.201 14.2631L21.6556 5.26312C21.829 4.62699 21.3502 4.00001 20.6908 4.00001H6.01395L5.58319 2.42587L5.5742 2.39742C5.31134 1.56552 4.53957 1 3.66714 1H1.3999C0.847616 1 0.399902 1.44772 0.399902 2C0.399902 2.55228 0.847616 3 1.3999 3L3.66677 3L7.37589 16.5543C7.61425 17.4253 8.40669 18.0285 9.30972 18.0264L20.4023 18ZM8.52763 13L6.61854 6.00001H19.3815L17.4725 13H8.52763ZM12 21C12 22.1046 11.1046 23 10 23C8.89544 23 8.00001 22.1046 8.00001 21C8.00001 19.8954 8.89544 19 10 19C11.1046 19 12 19.8954 12 21ZM19 23C20.1046 23 21 22.1046 21 21C21 19.8954 20.1046 19 19 19C17.8954 19 17 19.8954 17 21C17 22.1046 17.8954 23 19 23Z"
  }));
});
var DescriptiveCart = AbstractIcon.withComponent(Icon);
DescriptiveCart.displayName = 'DescriptiveCart';
export default DescriptiveCart;